import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "new-icon",
  role: "img",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M13.9203 2.90007C12.7866 2.03371 11.2147 2.03364 10.0808 2.89986L8.67496 3.97315L6.9271 4.20554C5.5116 4.39314 4.3974 5.50625 4.20853 6.92187L3.97407 8.6754L2.89995 10.0807C2.03462 11.2135 2.03467 12.7865 2.9 13.9193L3.9737 15.3246L4.20545 17.0735C4.39294 18.4893 5.50597 19.6036 6.92183 19.7924L8.67603 20.027L10.0807 21.1C11.2145 21.9663 12.7865 21.9663 13.9203 21.0999L15.3259 20.0259L17.0734 19.7945C18.4892 19.607 19.6036 18.4939 19.7924 17.078L20.026 15.3244L21.0999 13.9194C21.9666 12.7851 21.9648 11.2133 21.1002 10.08L20.0282 8.67473L19.7965 6.92547C19.609 5.50973 18.4958 4.39534 17.0799 4.20655L15.3247 3.97288L13.9203 2.90007Z" }, null, -1)
  ])))
}
export default { render: render }